/**
 * passport相关功能
 *
 * APPID
    58同城宝后端
    1002109-wb@sWT3aBzeN
    58同城百度小程序
    1002106-wb@bdY9w2Db2
    58精选微信小程序
    1002105-wb@wa1JP7ZKc
    58同城宝移动网页端
    1002104-wb@mHvWR7UgT
    <------appid------>
    加密前：1002104-wb@mHvWR7UgT
    <------encrypted appid------>
    加密后：k70Rrq7PzXPUVwCOxQmkMHgoXlwi1xaiDgNDw9DpyUcPPMaOGJ0v7FMVETBmOezd%2FSQPueQTavS5sd5dR0efs4aYRtqac0OVwVtuisY08uUv9PB0z7DxgTCNm0anvyay86LLOpOPCl8KuCAweT0e9SIhGrb7r4CM8bwYuOmdqCQ%3D
    <------end------>

    微聊appid加密方式（微聊提供）：http://igit.58corp.com/teg-app-fe/im-58-wap-jsencrypt
    需在本地运行，代码中只填充加密后的appid




    登录source：
    H5：58-tongchengbaoh5-m
    微信小程序：58-tongchengbao-weapp
    百度小程序：58-tongchengbao-bdapp
 */
import buildRequestParam from './buildRequestParam.js';

const source = '58-tongchengbaoh5-m'; // 同城宝passport登录source 用于验证调用方身份
const appid = 'k70Rrq7PzXPUVwCOxQmkMHgoXlwi1xaiDgNDw9DpyUcPPMaOGJ0v7FMVETBmOezd%2FSQPueQTavS5sd5dR0efs4aYRtqac0OVwVtuisY08uUv9PB0z7DxgTCNm0anvyay86LLOpOPCl8KuCAweT0e9SIhGrb7r4CM8bwYuOmdqCQ%3D'

function errorCk() {
    console.log('接口调用失败');
}

/**
 * 登录状态校验
 */
function checkLogin(cb) {
    $.ajax({
        type:'get',
        url:'/api/v2/userid',
        data:buildRequestParam({}, 'v2'),
        success:(res)=>{
            if(res.code === 1){
                cb && cb(res.data)
            }else{
                errorCk()
            }
        }
    })
}
/**
 * 现有M页登录
 */
function loginFromM({url = ''}) {
    const loginUrl = 'https://passport.58.com/m/login';
    const params = {
        path: encodeURIComponent(url), // 默认跳转M个人中心首页
        source: source, // 必填 用于验证调用方身份
        defaulttype: '', // 默认展示的登录方式：1.默认展示账号密码登录  2.默认展示手机号动态码登录
        onlymobile: '1', // 限制只能用手机号动态码登录：业务需要则传onlymobile=1即可
        onlypwd: '', // 限制只能用账号密码登录：    业务需要则传onlypwd=1即可
        ishidethird: '1', // 是否隐藏第三方登录方式：   ishidethird=1即可隐藏
        ishidetpage: '1' // 是否隐藏左上角首页链接：   ishidetpage=1即可隐藏
    };
    let paramString = '';
    for (const key in params) {
        if (params[key]) {
            paramString += `${key}=${params[key]}&`;
        }
    }
    paramString = paramString.slice(0,paramString.length -1);
    window.location.href = `${loginUrl}?${paramString}`;
}

export {
    checkLogin,
    loginFromM,
    appid
};
